import PropTypes from "prop-types";
import CardProgram from "./cards/CardProgram"; // eslint-disable-line

export default function ProgramIndex({ programCards }) {
	const programData = JSON.parse(programCards);

	const renderedProgramCards = programData.map((program) => (
		<CardProgram key={program.id} item={program} />
	));

	return (
		<ul>
			{renderedProgramCards}
		</ul>
	);
}

ProgramIndex.propTypes = {
	programCards: PropTypes.string.isRequired,
};
